import { Component, OnInit } from '@angular/core';
import { Customer } from '../../../agatextscreens/accounting/customer';
import { Branch } from '../../../agatextscreens/accounting/branch';
import { CustomerService } from '../../../agatextscreens/accounting/customer/customer.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-customer-autocomplete',
  templateUrl: './customer-autocomplete.component.html',
  styleUrls: ['./customer-autocomplete.component.scss']
})
export class CustomerAutocompleteComponent implements OnInit {

  subscription: Subscription = new Subscription();

  selectedCustomer: Customer;
  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  constructor(private _customerService: CustomerService) { }

  ngOnInit() {

    this.subscription = this._customerService
      .getCustomers()
      .subscribe((customers: Customer[]) => {
        this.allCustomers = customers;
        this.matchingCustomers = customers.slice(0,100);

        //this._loadingService.resolve('loading');
      });

  }


  setSelected(customer: Customer) {
    this.selectedCustomer = customer;
  }


  filter(input: string) {

    console.log('input: ' + input);

      this.matchingCustomers = this.allCustomers.filter(
        (cust: Customer) => {
          let full_name = cust.prefix + ' - ' + cust.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,100); // limit the matches to 100
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/components/customer-autocomplete/customer-autocomplete.component.ts